module.exports = __webpack_public_path__ + "img/Vector13.bb2341b1.svg";